import { useEffect, useState, RefObject } from 'react';

interface UseOnScreenOptions {
    threshold?: number | number[];
}

export default function useOnScreen(
    ref: RefObject<HTMLElement | null> | undefined,
    options: UseOnScreenOptions = {},
): { isOnScreen: boolean; isAbove: boolean } {
    const { threshold = 0 } = options;
    const [isOnScreen, setIsOnScreen] = useState(false);
    const [isAbove, setIsAbove] = useState(false);

    useEffect(() => {
        const element = ref?.current;
        if (!element) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsOnScreen(entry.isIntersecting);
                setIsAbove(entry.boundingClientRect.top < 0);
            },
            { threshold },
        );
        observer.observe(element);

        return () => {
            observer.disconnect();
        };
    }, [ref, threshold]);

    return { isOnScreen, isAbove };
}
